import {useEffect, useRef} from 'react'

const useProductTileHover = ({
    isOOS,
    isNotifyMeModalOpen,
    isShopSimilarModalOpen,
    setIsHovered,
    setIsQuickViewOpen,
    setMobileQuickViewOpenInternal,
    triggerFreshLikesFetch,
    tileRef
}) => {
    const lastViewportWidthRef = useRef(
        typeof window !== 'undefined' ? window.innerWidth : 0
    )

    const handleMouseEnter = () => {
        if (!isOOS) {
            setIsHovered(true)
        }
        // Trigger fresh likes count fetch on hover to bypass cache (BD specification)
        triggerFreshLikesFetch()
    }

    const handleMouseLeave = () => {
        if (!isNotifyMeModalOpen && !isOOS) {
            setIsHovered(false)
        }
    }

    useEffect(() => {
        if (!isNotifyMeModalOpen) {
            setIsHovered(false)
        }
    }, [isNotifyMeModalOpen, setIsHovered])

    useEffect(() => {
        const handleInteractOutside = (event) => {
            if (isNotifyMeModalOpen || isShopSimilarModalOpen) {
                return
            }

            const target = event?.target
            if (!(target instanceof Node)) {
                return
            }

            const currentTile = tileRef?.current
            const isInsideCurrentTile = currentTile ? currentTile.contains(target) : false
            if (isInsideCurrentTile) {
                return
            }

            const quickViewTrigger = target.closest?.('[data-testid="quick-add"]')
            if (quickViewTrigger || !target.closest?.('[data-product-tile="true"]')) {
                setIsHovered(false)
                setIsQuickViewOpen(false)
            }
        }

        document.addEventListener('pointerdown', handleInteractOutside, true)
        document.addEventListener('focusin', handleInteractOutside, true)

        return () => {
            document.removeEventListener('pointerdown', handleInteractOutside, true)
            document.removeEventListener('focusin', handleInteractOutside, true)
        }
    }, [isNotifyMeModalOpen, isShopSimilarModalOpen, setIsHovered, setIsQuickViewOpen])

    useEffect(() => {
        const hideQuickViewMobile = () => {
            // Android virtual keyboard can trigger resize with same width
            // (height-only change). Do not close quick view in that case.
            const nextWidth = window.innerWidth
            const hasViewportWidthChanged = nextWidth !== lastViewportWidthRef.current
            lastViewportWidthRef.current = nextWidth

            if (!hasViewportWidthChanged) {
                return
            }

            setMobileQuickViewOpenInternal(false)
        }

        window.addEventListener('resize', hideQuickViewMobile)
        return () => window.removeEventListener('resize', hideQuickViewMobile)
    }, [setMobileQuickViewOpenInternal])

    return {handleMouseEnter, handleMouseLeave}
}

export default useProductTileHover
